<template>
  <v-input :value="value" :rules="rules">
    <label style="position:absolute;top:0;left:0;">{{ label }}</label>
    <div style="margin-top:22px;">
      <quill-editor
        :ref="quillRef(0)"
        :options="editorOption"
        :value="innerValue"
        @input="innerValue = $event"
      />
    </div>
  </v-input>
</template>

<script>
export default {
  props: ["value", "rules", "label"],
  data() {
    return {
      innerValue: null,
      editorData: "<p>Rich-text editor content.</p>",
      editorOption: {
        modules: {
          // toolbar: {
          //   handlers: {
          //     // handlers object will be merged with default handlers object
          //     link: function(value) {
          //       console.log("link: ", value);
          //       if (value) {
          //         var href = prompt("Enter the URL");
          //         this.quill.format("link", href);
          //       } else {
          //         this.quill.format("link", false);
          //       }
          //     },
          //   },
          // },
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"], // remove formatting button
            ["link", "image", "video"],
            ["theme-btn"],
          ],
        },
      },
      btnListeners: [],
    };
  },
  computed: {
    computedSystemColors() {
      return Object.keys(this.systemColors).map((o) => o.toLowerCase());
    },
  },
  watch: {
    value: {
      handler(v) {
        console.log("value: ", v, this.systemColorsOnly, this.useSystemColors);
        this.innerValue = v;
      },
    },
    innerValue: {
      handler(v) {
        console.log(v);
        this.$emit("update:value", v);
      },
    },
  },
  mounted() {
    this.innerValue = this.value;
    this.$nextTick(() => {
      let quillref = this.$refs[this.quillRef(0)];

      if (Array.isArray(quillref)) {
        quillref = quillref[0];
      }

      //console.log(quillref);
      if (quillref !== null && quillref !== undefined) {
        var themeButton = quillref.$el.querySelector(".ql-theme-btn");
        const listener = function() {
          //console.log("function called");
          var range = quillref.quill.getSelection();
          if (range) {
            //console.log("range is valid");
            quillref.quill.formatText(range, "theme-btn");
          } else {
            //console.log("it it invalid");
          }
        }
        themeButton.addEventListener("click", listener);
        this.btnListeners.push({ themeButton, listener });
      }
    });
  },
  beforeDestroy() {
    this.btnListeners.forEach(({ btn, listener }) => {
      btn.removeEventListener("click", listener);
    });
  },
  methods: {
    quillRef(index) {
      const name = "quillEditor" + index.toString();
      // console.log(name);
      return name;
    },
    customLinkHandler(value, quillRefIndex) {
      //console.log("link: ", value, quillRefIndex);
      if (value) {
        this.quill = this.$refs[this.quillRef(quillRefIndex)][0].quill;
        this.link = {};
        this.linkDialog = true;
      } else {
        this.quill.format("link", false);
        this.quill = null;
        this.link = null;
      }
    },
    saveLink() {
      if (this.link.isButton) {
        const range = this.quill.getSelection({ focus: true });
        // console.log("clicked: ", range);
        if (range) {
          this.quill.formatText(range.index, range.length, "theme-btn");
          // const text = this.quill.getText(range.index, range.length);

          // let ThemeBtn = new Parchment.Attributor.Class("theme-btn", "theme-btn");
          // Parchment.register(ThemeBtn);

          // let btn = document.createElement("div");
          // btn.innerHTML = '<a href="'+this.link.url+'">'+text+'</a>';
          // ThemeBtn.add(btn, "theme-btn");
          // console.log(btn.outerHTML); // Will print <div class="blot-align-right"></div>

          // // const btn = '<div class="theme-btn">' + text + '</div>';

          // this.quill.deleteText(range.index, range.length);

          // this.quill.insertEmbed(
          //   range.index,
          //   btn
          // );
          // quill.setSelection(range.index, btn.length)
          // this.quill.format("class", "theme-btn")

          // this.quill.formatText(range.index, range.length, {
          //   class: "theme-btn",
          //   link: this.link.url,
          // });

          // var quill = new Quill('#editor', {
          //   theme: 'snow',
          //   modules: {
          //     toolbar: [
          //       ['theme-btn']
          //     ]
          //   }
          // });
          this.quill.format("theme-btn");
        }
      } else {
        this.quill.format("link", this.link.url);
      }
      this.linkDialog = false;
      //console.log(this.quill.getContents());
    },
  },
};
</script>
